import { ApiError } from '@esnafai/shared/api';
import { useToast } from '@esnafai/shared/ui';
import { useCallback } from 'react';
import { t } from '@esnafai/shared/i18n';

// The error toast of a failed action (merchant screens §4.2): the ApiError's catalog text, and *Hata kodu* copying
// its X-Trace-Id. A validation_failed error gives no toast: the form shows it on its fields (UI architecture §4).
export function useActionError(): (error: unknown) => void {
  const { toast } = useToast();
  return useCallback(
    (error: unknown) => {
      if (!(error instanceof ApiError)) {
        toast({ tone: 'danger', title: t('errors.type.internal') });
        return;
      }
      if (error.type === 'validation_failed') return;
      toast({ tone: 'danger', title: error.message, traceId: error.traceId ?? undefined });
    },
    [toast],
  );
}
